import { useProvideInject } from "../lib/provideInjectGenerator";
import { BetData } from "../types/betData";
import { AdTag } from "../types/index";

export const AdTagSymbol = Symbol("AdTagSymbol");
export const {
  provider: provideAdTag,
  injector: injectAdTag
} = useProvideInject<AdTag>(AdTagSymbol, {} as AdTag);

export const BetDataSymbol = Symbol("BetDataSymbol");
export const {
  provider: provideBetData,
  injector: injectBetData
} = useProvideInject<BetData>(BetDataSymbol, {} as BetData);

export const UseOfferSymbol = Symbol("UseOfferSymbol");
export const {
  provider: provideUseOffer,
  injector: injectUseOffer
} = useProvideInject<boolean>(UseOfferSymbol, false);
